import PageOne from "./PageOne/PageOne";
import PageTwo from "./PageTwo/PageTwo";
import PageThree from "./PageThree/PageThree";
import PageFour from "./PageFour/PageFour";
import React, { useState, useEffect } from "react";
import MultiStepProgressBar from "./MultiStepProgressBar/MultiStepProgressBar";
import Header from '../Header/Header'
import Footer from "../Footer/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio, AvInput } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { connect } from "react-redux"
// import { loginUser, apiError, socialLogin } from "../../store/actions"
import { loginSuccess, registerUserSuccessful  } from "../store/actions"
import { withRouter, Link } from "react-router-dom"
import PropTypes from 'prop-types'
import { post } from "../helpers/api_helper";
import PageFive from "./PageFive/PageFive";
import { toast } from "react-toastify";
function Register(props) {
  const [page, setPage] = useState("pageone");
  const [loginpage, setLoginpage] = useState(false);
  const [repage, setRepage] = useState(false);
  const [registerForm, setRegisterForm] = useState(false);
   const [nextStep, setNextStep] = useState(false);
   const [coursetype, setCoursetype] = useState("");
   const [apptype, setApptype] = useState("");
   const [hide, setHide] = useState(false);
   const [expe, setExpe] = useState(false);
   const [nextBTN, setNextBTN] = useState(false);
   const { user } = props;



  const [setpone, setStepone] = useState(null);

  useEffect(()=>{
    getStep();

  }, []);


  useEffect(()=>{
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  },[])

  useEffect(()=>{
//  console.log('user on login page',user);
  }, [user]);

  const email_ = localStorage.getItem('email');

  const getStep=async()=>{
    var data = await localStorage.getItem("authUser");
    if(data){
      data=JSON.parse(data);
      setStepone(data?.step);
    }
  }

  const nextPage = (page) => {
    setPage(page);
  };

  const nextPageNumber = (pageNumber) => {
    switch (pageNumber) {
      case "1":
        setPage("pageone");
        break;
      case "2":
        setPage("pagetwo");
        break;
      case "3":
        setPage("pagethree");
        break;
      case "4":
      setPage("pagefour");
      break;
      case "5":
        setPage("pagefive");
        break;
      default:
        setPage("1");
    }
  };



  const handleValidSubmit = (event, values) => {

    console.log('values',values)
    let body ={
      ...values,
      email:email_
    }
    // props.loginUser(values, props.history);
    post('/register', body)
    .then((json=>{
      // console.log('response data register', json);
      if(json.statusCode == 200){

        // props.registerUserSuccessful(json);
        toast.success(json?.message);
        nextStepfunction();
      }else{
        toast.error(json?.error)
      }

    }))


  }

  const nextStepfunction = () =>{
    setTimeout(()=>{
      nextStepFunc();
    },1000)
  }

  const nextStepFunc = (nextStep) =>{
    setNextStep(nextStep)
  }

  const courseType = (e) =>{
    console.log(e.target.value)
    if(e.target.value == '5th'){

      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(false)
    }else if(e.target.value == '8th'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(false)
    }else if(e.target.value == '10th'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(false)
    }else if(e.target.value == '12th'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(false)
    }else if(e.target.value == 'Diploma'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(true)
    }else if(e.target.value == 'Bachelor'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(true)
    }else if(e.target.value == 'Master'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(true)
    }else if(e.target.value == 'Phd'){
      setHide(true);
      setCoursetype(e.target.value)
      setNextBTN(true)
    }else if(e.target.value == ''){
      setHide(false);
      setCoursetype(e.target.value)
    }else{
      setHide(false);
    }
  }

  const userTypeFunc = (e) =>{
if(e.target.value == 'Experienced'){
  setExpe(true);
}else{
  setExpe(false);
}
  }


const appTypeFunc = (e) =>{
  setApptype(e.target.value);
  if(e.target.value == 'NATS'){
    if(coursetype == "5th"){
      // console.log('error Min Qualification Diploma')
      toast.error('Min Qualification Diploma')
      setNextBTN(false)
    }else if(coursetype == "8th"){
      toast.error('Min Qualification Diploma')
      setNextBTN(false)
    }else if(coursetype == "10th"){
      toast.error('Min Qualification Diploma')
      setNextBTN(false)
    }else if(coursetype == "12th"){
      toast.error('Min Qualification Diploma')
      setNextBTN(false)
    }else{
      setNextBTN(true)
    }

  }else{
    setNextBTN(true)
  }
}

  return (
    <>
      <Header />

      <div className="auth-section">
      <Container fluid>
         <Row>
          {
            nextStep == false ? <Col lg={12}>
            <AvForm
              onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
              }}
            className="user_form_n">
              <h5>Welcome to the Apprenticeshipwale enrollment process. Please Answer the below questions to quickly check your eligibility!</h5>
              <div className="user_form">
              <h6 className="form-paragraph">
                 <p>I am a Student that </p>
                 <AvField type="select" onChange={userTypeFunc} className="custom-field" name="studentType" required>
                 <option></option>
                 <option value="Pursuing">Pursuing</option>
                 <option value="Complete">Completed</option>
                 <option value="Experienced">have Experienced</option>
                 </AvField>
                 {
                  expe == true ? <p>In</p>:null
                 }

                 <p>, and My highest qualification is</p>
                 <AvField type="select" onChange={courseType} name="select" required>
                 <option value=""></option>
                 <option value="5th">5th</option>
                 <option value="8th">8th</option>
                 <option value="10th">10th</option>
                 <option value="12th">12th</option>
                 <option value="Diploma">Diploma</option>
                 <option value="Bachelor">Graduate</option>
                 <option value="Master">Post Graduate</option>
                 <option value="Phd">PHD</option>
               </AvField>
               <p>My Name is </p>
               <AvField type="text" name="name" required />
                  <p>, I would like to enroll myself in the</p>
                  <AvField type="select" onChange={appTypeFunc}  className="custom-field" name="appType" required>
                 <option></option>
                 <option value="NATS">NATS</option>
                 <option value="NAPS">NAPS</option>
                 </AvField>
                 <p>Portal.</p>
                 </h6>

              </div>

              <Button
              type="submit"
              className="common-btn"
              // disabled={nextBTN == false ? 'disabled':null}
              style={{cursor: nextBTN == false ? 'no-drop' : 'pointer'}}
              >
              Next
              </Button>
            </AvForm>
         </Col>:<Col lg={12} className="register-box">
           <MultiStepProgressBar page={page} expe={expe} onPageNumberClick={nextPageNumber} />
               {
                 {
                   pageone: <PageOne history={props.history} apptype={apptype} registerUserSuccessful={props.registerUserSuccessful} email={email_} nextStepFunc={nextStepFunc} onButtonClick={nextPage} />,
                   pagetwo: <PageTwo history={props.history} registerUserSuccessful={props.registerUserSuccessful} email={email_} expe={expe} hide={hide} coursetype={coursetype} onButtonClick={nextPage}  />,
                   pagethree: expe == true ? <PageThree registerUserSuccessful={props.registerUserSuccessful} email={email_} history={props.history} onButtonClick={nextPage}   />:null,
                   pagefour: <PageFour history={props.history} registerUserSuccessful={props.registerUserSuccessful} email={email_} expe={expe} onButtonClick={nextPage}  />,
                   pagefive: <PageFive history={props.history} registerUserSuccessful={props.registerUserSuccessful} email={email_} onButtonClick={nextPage}  />,

                 }[page]
               }
           </Col>
          }


         </Row>
       </Container>
      </div>
      <Footer />
    </>
  );
}

const mapStateToProps = state => {
  const { user } = state
  return { user }
}

export default withRouter(
  connect(mapStateToProps, { loginSuccess })(Register)
)


Register.propTypes = {
  history: PropTypes.object,
  loginSuccess: PropTypes.func
}